import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";

export const getErrorMessage = (error: FetchBaseQueryError | SerializedError | undefined) => {
    if (isFetchBaseQueryError(error)) {
        return "error" in error ? error.error : JSON.stringify(error.data);
    } else if (isErrorWithMessage(error)) {
        return error.message;
    }
};

const isFetchBaseQueryError = (error: unknown): error is FetchBaseQueryError => {
    return typeof error === "object" && error != null && "status" in error;
};

const isErrorWithMessage = (error: unknown): error is { message: string } => {
    return (
        typeof error === "object" &&
        error != null &&
        "message" in error &&
        typeof (error as any).message === "string"
    );
};
